export default "__VITE_ASSET__BBzPMxsF__"